import { render, staticRenderFns } from "./ThaiAddressInput.vue?vue&type=template&id=c4a78748&scoped=true&"
import script from "./ThaiAddressInput.vue?vue&type=script&lang=js&"
export * from "./ThaiAddressInput.vue?vue&type=script&lang=js&"
import style0 from "./ThaiAddressInput.vue?vue&type=style&index=0&id=c4a78748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a78748",
  null
  
)

export default component.exports